import { ReactNode } from "react";

import {
    FullScreenPage,
    FullScreenRouterState,
    useFullScreenClose,
} from "@accurx/navigation";
import { matchPath, useLocation } from "react-router-dom";

import { ROUTES_COMPOSE } from "../Routes.constants";
import { useComposeVariant } from "./hooks/useComposeVariant";

/**
 * Displays children wrapped around unified navigation
 * full screen modal layout
 *
 * This is the place where we keep track of different entry points
 * to then go "back" to, regardless of which page we're on within the flow.
 */
export const FullScreenPageWrapper = ({
    children,
}: {
    children: ReactNode;
}) => {
    const { pathname } = useLocation<FullScreenRouterState>();

    const handleFullScreenClose = useFullScreenClose();

    const variant = useComposeVariant();

    const isClinicianCompose =
        matchPath(pathname, {
            path: ROUTES_COMPOSE.clinicianCompose,
            exact: false,
            strict: false,
        }) || variant === "Clinician";

    return (
        <FullScreenPage
            header={
                isClinicianCompose ? "New GP message" : "New patient message"
            }
            onClose={handleFullScreenClose}
        >
            {children}
        </FullScreenPage>
    );
};
